<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters v-if="!data.reduced">
        <!-- componente a parte ha flag obbligatorio -->
                    <v-radio-group class="pa-0 ma-0 d-flex flex-grow-1 flex-shrink-0" disabled v-model="measures.zero_device" label="Mantenimento dello zero">
                        <v-radio label="Attivo" value="on"></v-radio>
                        <v-radio label="Disattivo" value="off"></v-radio>
                        <v-radio label="Fuori zona intervento" value="out"></v-radio>
                    </v-radio-group>
                    <!-- componente a parte ha flag obbligatorio e meccanico-->
                    <v-radio-group v-if="has_hi_res" class="pa-0 ma-0 d-flex flex-grow-1 flex-shrink-0" :disabled="preview" v-model="measures.hi_res" label="Alta risoluzione">
                        <v-radio label="Attivo" value="on"></v-radio>
                        <v-radio label="Disattivo" value="off"></v-radio>
                    </v-radio-group>
                </v-row>
                <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-end py-2" v-if="!preview">
                    <v-btn @click="convertPlaceholders(measures.items)" color="primary">Riempimento automatico</v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters>
            <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.rif}}</th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items" :key="index" class="align-end justify-center fill-height">
                        <td class="table-blocks d-flex align-center">
                                <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                                <div v-else class="d-flex mr-6"></div>
                                <div class="d-flex justify-center flex-shrink-0 flex-grow-1">{{ index + 1 }}</div>
                        </td>
                        <td class="table-blocks" :rowspan="measures.items.length" v-if="index==0">
                            <NumericField dense outlined
                                @input="changeMass()"
                                solo hide-details
                                :readonly="preview"
                                v-model="measures.mass"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(measures.mass)"
                            ></NumericField> 
                        </td>
                        <td class="table-blocks">
                            <NumericField dense outlined
                                @input="changeReading(item)"
                                solo hide-details
                                :readonly="preview"
                                v-model="item.reading"
                                :precision="currentPrecision"
                                :negative="false"
                                :placeholder="readingPlaceholder(item.mass)"
                                :class="readingWarning(item.reading)"
                                :enableicons="!preview"
                                :addfunc="readingAddFunc"
                                :subfunc="readingSubFunc"
                                :row="item"
                                :fieldname="'reading'"
                                :range="calcMinRange(item.reading)"
                            ></NumericField> 
                        </td>
                        <td v-if="measures.hi_res=='off'" class="table-blocks">
                            <NumericField dense outlined
                                @input="changeAddLoad(item)"
                                solo hide-details
                                :readonly="preview"
                                v-model="item.addLoad"
                                :precision="high_precision"
                                :negative="false"
                                :placeholder="calculateAddLoadPlaceholder(item.reading)"
                                :class="addLoadWarning(item.addLoad, item.reading)"
                                :enableicons="!preview"
                                :addfunc="loadAddFunc"
                                :subfunc="loadSubFunc"
                                :row="item"
                                :fieldname="'addLoad'"
                                :range="calcMinRange(item.reading)"
                            ></NumericField>
                        </td>
                        <td v-if="measures.hi_res=='off'" class="table-text-blocks text-right">
                            <b>{{ item.p  | formatNumber}}</b>
                        </td>
                    </tr>
                </template>
            </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                    <div v-if="addLoad_overflow" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                </div>        
                <div class="d-flex flex-grow-0 flex-shrink-1 my-2">
                    <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                </div>
            </v-row>
            <v-row no-gutters class="d-flex justify-end">
                <div class="add_table text-center elevation-2 mb-2">
                    <table class="py-2 px-6">
                        <tr><td class="text-right">Carico da 1 a {{ measures.items.length }}:</td><td class="text-right pl-2"><b>{{totalReading | formatNumber}} {{this.instrument_data.uom}}</b></td></tr>
                        <tr><td class="text-right">
                            <span v-if="measures.hi_res=='off'">Pmax - Pmin:</span>
                            <span v-else>Imax - Imin:</span></td><td class="text-right pl-2"><b>{{measures.diff | formatNumber}} {{this.instrument_data.uom}}</b>
                        </td></tr>
                        <tr><td class="text-right">MPE:</td><td class="text-right pl-2"><b>{{measures.mpe | formatNumber}} {{this.instrument_data.uom}}</b></td></tr>
                        <tr><td class="text-right">
                            ESITO:</td>
                            <td class="text-right pl-2">
                            <StatusIcon :status="measures.result" :tooltip_text="block_tooltip[measures.result]" />
                        </td></tr>
                    </table>
                </div>
            </v-row>
            </v-container>
        </div>
    </LayoutBlock>
</template>
<script>
import {repeatability_item} from "../../../utils/itemBlockSchema"
import {BaseLeg} from "../../../utils/baseLeg"
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from '../../../components/utils/StatusIcon'
import {normalMPE, restrictedMPE} from "../../../utils/common"
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon},
    mixins: [BaseLeg],
    computed: {
        rowsCount() {
            return this.measures.items.length;
        },
        totalReading(){
            let temp = Big(0);
            if(this.measures.hi_res == 'off'){
                for(let item of this.measures.items){
                    if(item.p){
                        temp = temp.plus(item.p)
                    }
                }
            } else {
                for(let item of this.measures.items){
                    if(item.reading){
                        temp = temp.plus(item.reading)
                    }
                }
            }
            return this.round(temp, this.high_precision);
        }
    },
    methods: {
        changeMass() {
            if(this.measures.mass){
                for (var item of this.measures.items) {
                    item.mass = this.measures.mass;
                }
                if(this.measures.items && this.measures.items.length > 0){
                    this.measures.items[0].reading = this.measures.mass
                }
                if(this.measures.restrictive_mode == "on"){
                    let minRange = this.instrument_data.ranges[0]
                    let maxAllowed = Big(minRange.e).times(2).toString()
                    this.measures.mpe = maxAllowed
                } else {
                    this.measures.mpe = this.calc_MPE(this.calcMinRange(this.measures.mass), this.measures.mass)
                }
            }
        },
        addRow(){
            let item = repeatability_item({
                index: this.measures.items.length,
                mass: this.measures.mass
            })
            this.measures.items.push(item)
        },
        calcDiff(){
            let targets = [];
            for (let item of this.measures.items) {
                let t = 0
                if (this.measures.hi_res == 'off') {
                    t = item.p;
                } else {
                    t = item.reading;
                }
                targets.push(t)
            }
            let min = Math.min.apply(Math, targets);
            let max = Math.max.apply(Math, targets);
            this.measures.diff = this.differenceInt(max,min)
        },
    
        async buildMeasures() {
            this.measures = {
                items: [],
                zero_device: this.conf.zero_device,
                hi_res: this.conf.hi_res,
                restrictive_mode: this.conf.restrictive_mode,
                mpe: 0,
                diff: 0,
                mass: 0,
                result: 'uncomplete'
            }
            this.measures.hi_res = this.has_hi_res ? this.conf.hi_res : 'off'
            let currentRange = this.findMaxRange()
            let catMass =  await this.buildWithCategory()
            this.measures.mass = catMass ? catMass: this.round(0)
            if(this.measures.restrictive_mode == "on"){
                let minRange = this.instrument_data.ranges[0]
                let maxAllowed = Big(minRange.e).times(2).toString()
                this.measures.mpe = maxAllowed
            } else {
                this.measures.mpe = this.calc_MPE(currentRange, this.measures.mass)
            }
            let item1 = repeatability_item({
                index: 1,
                mass: this.measures.mass,
                reading: this.measures.mass,
                result: 'done'
            })
            this.measures.items.push(item1)
            for (let i = 2 ; i <= this.conf.min_readings ; i++){
                let item = repeatability_item({
                    index: i,
                    mass: this.measures.mass 
                })
                this.measures.items.push(item)
            }
        },
        calcBlockResult() {
            let m_result = 'done'
            m_result = this.measures.items.reduce(function(result, item) {
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            let res = 'uncomplete'
            switch(m_result) {
                case 'uncomplete':
                    break
                case 'failed':
                    res = 'failed'
                    break
                case 'done':
                    if(this.precision_overflow){
                        res = 'failed' 
                    } else if(this.measures.hi_res == 'off' && this.addLoad_overflow ){
                        res = 'failed'
                    } else {
                        res = Big(this.measures.diff).lte(this.measures.mpe) ? 'done' : 'failed'
                    }
                    break
            }
            this.measures.result = res
        },
        saveMeasures() {
            console.log("$$ saving measures", this.data.reduced)
            let block = this.data.block
            this.calcBlockResult()
            if(this.data.reduced == true){
                console.log("$$ emitting from rep", this.data.reduced)
                this.$emit('updateMeasures', {name: this.data.block.name, measures: this.measures})
            } else {
                this.data.common_data[block.name][block._id].value = {result: this.measures.result, mass: this.measures.mass, restricted: this.measures.restrictive_mode}
                this.$parent.$emit('updateMeasure', {b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id, common_data: this.data.common_data })
            }
                
        },
    },
  
}
</script>

